import "../css/hover-links.css";
import { convertToSlug } from './utils.js';
jQuery(document).ready(function () {
  console.log("hover-links.js loaded");
  // Scroll page if the URL has hash
  if (jQuery(location).attr("hash")) {
    let selector = jQuery(location).attr("hash");
    let paddingTop = 20;
    jQuery("html, body").animate(
      { scrollTop: jQuery(selector).offset().top - paddingTop },
      "slow"
    );
  }
});


const copyToClipboard = async (url) => {
  var data = [
    new ClipboardItem({
      "text/plain": new Blob([url], { type: "text/plain" }),
    }),
  ];
  navigator.clipboard.write(data).then(
    function () {
      showCopiedMessage(url);
      console.log("Copied to clipboard successfully!");
    },
    function () {
      console.error("Unable to write to clipboard.");
    }
  );
};

const showCopiedMessage = (url) => {
  jQuery("span.copied").fadeIn(300).delay(1000).fadeOut(500);
};


// Funciones globales, disponibles para otros archivos JS
window.copyToClipboard = copyToClipboard;
